<template>
  <div class="api-item" v-if="item">
    <img
      class="api-item-image"
      :src="item.imgUrl"
      :alt="item.name"
      :title="item.name"
    />
    <p class="api-item-name">{{ item.name }}</p>
    <div class="api-item-desc">
      {{ item.remark }}
    </div>
    <!-- <span class="api-item-price">¥0.009/次</span> -->
    <button class="api-item-btn" @click="applyData(item.id)">申请数据</button>
  </div>
</template>

<script>
export default {
  methods: {
    applyData (id) {
      this.$router.push('/apiMargetDetail/' + id)
    }
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
.api-item {
  width: 232px;
  height: 240px;
  border: 1px solid #eee;
  border-radius: 4px;
  margin: 0 9px 22px;
  text-align: center;
  padding-top: 20px;
  position: relative;

  .api-item-image {
    width: 50px;
    height: 50px;
    object-fit: contain;
  }

  .api-item-price {
    color: #ff4d4f;
    font-size: 16px;
    padding-top: 10px;
  }

  .api-item-name {
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }

  .api-item-desc {
    padding: 8px 14px 0;
    font-size: 12px;
    color: #999;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .api-item-btn {
    position: absolute;
    left: 10%;
    bottom: 20px;
    width: 80%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #00bdff;
    border-radius: 4px;
    cursor: pointer;
    color: #fff;
    border: none;
  }
}

/* 移动端适配 - 不影响PC端 */
@media screen and (max-width: 768px) {
  .api-item {
    width: calc(50% - 12px);
    min-height: 200px;
    margin: 0 6px 16px;
    padding-top: 15px;

    .api-item-image {
      width: 40px;
      height: 40px;
    }

    .api-item-name {
      font-size: 13px;
    }

    .api-item-desc {
      font-size: 11px;
      padding: 5px 10px 0;
      -webkit-line-clamp: 2;
    }

    .api-item-btn {
      height: 26px;
      line-height: 26px;
      bottom: 15px;
      font-size: 12px;
    }
  }
}
</style>
<style lang="less" scoped>
.api-item {
  width: 100%; height: auto; min-height: 210px; margin: 0;
  padding: 18px 14px 14px; display: flex; flex-direction: column; align-items: center;
  border-color: #e3e9f0; border-radius: 10px; background: #fff;
  .api-item-name { margin-top: 10px; font-size: 15px; }
  .api-item-desc { padding: 8px 0 14px; color: #65758a; line-height: 1.6; }
  .api-item-btn { position: static; margin-top: auto; width: 100%; min-height: 36px; background: #2676d9; }
}
@media screen and (max-width: 768px) {
  .api-item { min-height: 190px; padding: 14px 10px 10px; }
  .api-item .api-item-name { font-size: 13px; }
  // 文案固定两行，独立预留按钮间距，避免 flex 收缩导致文字与按钮重叠。
  .api-item .api-item-desc {
    font-size: 12px; line-height: 18px; height: 36px;
    padding: 0; margin: 8px 0 12px; flex-shrink: 0;
    -webkit-line-clamp: 2;
  }
  .api-item .api-item-btn {
    width: auto; min-width: 96px; max-width: 100%; padding: 0 14px;
    height: 32px; min-height: 32px; line-height: 32px; flex-shrink: 0;
    font-size: 12px; align-self: center;
  }
}
</style>
